import CommissionLayout from '@/core/layout/commission/commission.layout'

const CommissionPage = () => {
    return <CommissionLayout />
}

export default CommissionPage

